define(function (require) {

    var _ = require('underscore');
    var ViewController = require('web-agent-framework/ViewController');

    ViewController.plugin({

        supportConfiguration: true,

        initialize: function (constructorData) {
            if (!constructorData.doNotInitializeView) { // This is done to identify that we are NOT at the "extend" part of the object creation and we are at the object instance creation.
                this.configuration = getConfiguration.call(this, constructorData);
            }

            function getConfiguration(constructorData) {
                // Setting the object's own constructor as the instance's initial super.
                this.super = Object.getPrototypeOf(this);
                // Calling the recursive function that will allocate all the configurations from this instance hierarchy tree.
                var extendedConfiguration = getExtendedConfiguration.call(this, this.super);
                // Adding to the instance configuration the constructorData provided when creating the instance.
                return extendConfigurationObject(extendedConfiguration, constructorData);
            }

            function getExtendedConfiguration(context) {
                // Setting the instance's super to it's higher class
                context.super = Object.getPrototypeOf(context);
                // Stopping the recursion
                if (!context || !context.getConfiguration) {
                    return {};
                }
                // Calling the higher levels of the instance to provide their configuration.
                return extendConfigurationObject(getExtendedConfiguration.call(this, context.super), context.getConfiguration.call(this));
            }

            // This method gets two objects, parent & child and merges all the child's content into the parent.
            // If the child a property that the parent has, it will override it.
            function extendConfigurationObject(parentConfigurationObject, childConfigurationObject) {
                if (parentConfigurationObject) {
                    if (childConfigurationObject) {
                        _.merge(parentConfigurationObject, childConfigurationObject);
                    }
                    return parentConfigurationObject;
                } else if (childConfigurationObject) {
                    return childConfigurationObject;
                } else {
                    return {};
                }
            }
        }
    });

    // todo - what to export?

});
